import api from "../services/api";


export const getAllCases = async () => api.get("/CaseHearing");
export const getCaseById = async (id) => api.get(`${"/CaseHearing"}/${id}`);
export const createCase = async (data) => api.post("/CaseHearing", data);
export const updateCase = async (id, data) => api.put(`${"/CaseHearing"}/${id}`, data);
export const deleteCase = async (id) => api.delete(`${"/CaseHearing"}/${id}`);
